import { render, staticRenderFns } from "./JColorBadge.vue?vue&type=template&id=2c251169&scoped=true&"
import script from "./JColorBadge.vue?vue&type=script&lang=js&"
export * from "./JColorBadge.vue?vue&type=script&lang=js&"
import style0 from "./JColorBadge.vue?vue&type=style&index=0&id=2c251169&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c251169",
  null
  
)

export default component.exports